export default __webpack_public_path__ + "static/grafika-promo-23610904611f7858a7d4f6284497fbf8.png";